/**
 * StVZO Warning System
 * Intercepts add-to-cart for products without road approval (StVZO).
 * Shows a confirmation modal before allowing the product to be added.
 */

if (typeof ModalElement !== 'undefined' && !customElements.get('stvzo-modal')) {
  class StVZOModalElement extends ModalElement {
    constructor() {
      super();
      this.events = {
        afterHide: 'stvzo:afterHide',
        afterShow: 'stvzo:afterShow'
      };
      this.pendingForm = null;
    }

    get shouldLock() {
      return true;
    }

    get shouldAppendToBody() {
      return false;
    }

    connectedCallback() {
      super.connectedCallback();

      // Capture-phase listener — fires BEFORE theme.js product-form handler
      document.addEventListener('submit', this.handleSubmit.bind(this), true);

      // Accept button
      const acceptBtn = this.querySelector('[data-stvzo-accept]');
      if (acceptBtn) {
        acceptBtn.addEventListener('click', this.handleAccept.bind(this));
      }
    }

    handleSubmit(event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      // Only intercept forms with the StVZO flag
      const stvzoFlag = form.querySelector('[data-stvzo-flag]');
      if (!stvzoFlag) return;

      // Check if already accepted
      const accepted = form.querySelector('input[name="properties[_stvzo_accepted]"]');
      if (accepted) return;

      // Block the submission
      event.preventDefault();
      event.stopImmediatePropagation();

      // Store reference to the form
      this.pendingForm = form;

      // Show the modal
      this.show();
    }

    handleAccept() {
      if (!this.pendingForm) return;

      // Save reference before hide() triggers beforeHide()
      const form = this.pendingForm;
      this.pendingForm = null;

      // Add hidden property to the form
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_stvzo_accepted]';
      input.value = 'Ja';
      form.appendChild(input);

      // Close modal
      this.hide();

      // Re-trigger the submit by clicking the submit button
      const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (submitBtn) {
        submitBtn.click();
      } else {
        form.requestSubmit();
      }
    }

    beforeHide() {
      this.pendingForm = null;
    }
  }

  customElements.define('stvzo-modal', StVZOModalElement);
}
